<h2 mat-dialog-title>Cable Diameter Calculator</h2>
<mat-dialog-content>
  <form [formGroup]="calculatorForm" class="calculator-form">
    <mat-form-field>
      <mat-label>Wire Diameter</mat-label>
      <input matInput type="number" formControlName="wireDiameter" step="0.001" />
      @if (
        calculatorForm.get('wireDiameter')?.hasError('required') &&
        calculatorForm.get('wireDiameter')?.touched
      ) {
        <mat-error>Wire diameter is required</mat-error>
      }
      @if (
        calculatorForm.get('wireDiameter')?.hasError('min') &&
        calculatorForm.get('wireDiameter')?.touched
      ) {
        <mat-error>Must be greater than 0</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Conductor Quantity</mat-label>
      <input matInput type="number" formControlName="conductorQuantity" />
      @if (
        calculatorForm.get('conductorQuantity')?.hasError('required') &&
        calculatorForm.get('conductorQuantity')?.touched
      ) {
        <mat-error>Conductor quantity is required</mat-error>
      }
      @if (
        calculatorForm.get('conductorQuantity')?.hasError('min') &&
        calculatorForm.get('conductorQuantity')?.touched
      ) {
        <mat-error>Must be at least 1</mat-error>
      }
    </mat-form-field>

    <div class="results">
      <p>
        <span class="font-medium">Cable Diameter: </span>
        <span>{{ calculatedDiameter }}</span>
      </p>
      <p>
        <span class="font-medium">Factor: </span>
        <span>{{ factor }}</span>
      </p>
      <p>
        <span class="font-medium">Lay Up: </span>
        <span>{{ layUp }}</span>
      </p>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="calculate()"
    [disabled]="!calculatorForm.valid"
  >
    Calculate
  </button>
</mat-dialog-actions>
